export default __webpack_public_path__ + "static/media/transpaletaEP-55.fa21273e.png";